export const FORM_VARIANT = {
  MAIN: 'main',
  REQUEST_DETAILS: 'request-details',
  REQUEST_FORM: 'request-form',
};
